/**
 * RNG deterministico (mulberry32). Avere una sorgente casuale iniettabile e
 * riproducibile rende testabile la battaglia e, in Fase 2, permette al server
 * di validare i risultati dei client condividendo il seed.
 */

export interface Rng {
  /** Numero in [0, 1). */
  next(): number;
  /** Intero in [min, max] inclusi. */
  int(min: number, max: number): number;
  /** True con probabilità p. */
  chance(p: number): boolean;
  /** Elemento casuale di un array non vuoto. */
  pick<T>(items: readonly T[]): T;
}

export function createRng(seed: number): Rng {
  let state = seed >>> 0;
  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (min, max) => min + Math.floor(next() * (max - min + 1)),
    chance: (p) => next() < p,
    pick: (items) => {
      if (items.length === 0) throw new Error('pick() su array vuoto');
      return items[Math.floor(next() * items.length)]!;
    },
  };
}

/** RNG non deterministico per il gameplay normale. */
export function randomRng(): Rng {
  return createRng((Math.random() * 2 ** 32) >>> 0);
}
